<template>
  <div>
    <template v-if="clas && !fetchLoading">
      <v-app-bar color="primary" flat app dark>
        <v-app-bar-nav-icon style="position: absolute" @click="goBackWithTab">
          <v-icon large color="white">mdi-chevron-left</v-icon>
        </v-app-bar-nav-icon>
        <v-spacer></v-spacer>
        <v-app-bar-title style="min-width: fit-content; font-size: 14px;">{{ clas.className }}</v-app-bar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="shouldShowClassDiary" style="position: absolute; right: 0" color="#FFFFFF" depressed @click="toClassDiary"
          >{{ $t('classDiary.classDiary') }}</v-btn>
      </v-app-bar>

      <v-progress-linear
        indeterminate
        color="primary"
        height="3"
        v-if="showLoader"
      ></v-progress-linear>

      <div @click="openDialog">
        <DatePager :date="date" @addDay="addDay" @subtractDay="subtractDay" />
      </div>

      <v-tabs v-model="tabIndex" color="primary" grow>
        <v-tab v-if="shouldShowRecords">{{ $t('classDiary.tabRecords') }}</v-tab>
        <v-tab v-if="shouldShowDiary">{{ $t('classDiary.tabDiary') }}</v-tab>
        <v-tab v-if="shouldShowMeal">{{ $t('classDiary.tabMeal') }}</v-tab>
      </v-tabs>

      <v-window v-model="tabIndex" v-if="children">
        <!-- 記録 🔽 -->
        <v-window-item v-if="shouldShowRecords">
          <OtherRecord :children="children" :clas="clas" :date="date" />
        </v-window-item>
        
        <!-- 日誌 🔽 -->
        <v-window-item v-if="shouldShowDiary">
          <ChildDiary :diaries="diaries" :children="children" :clas="clas" :absenceAttendance="absenceAttendance" :date="date" />
        </v-window-item>

        <!-- 喫食 🔽 -->
        <v-window-item v-if="shouldShowMeal">
          <EatingRecord :children="children" :clas="clas" :date="date" />
        </v-window-item>
      </v-window>
    </template>
    <template v-else>
      <VueLoading :height="'50vh'" />
    </template>

    <!--　カレンダー　-->
    <v-dialog
      v-model="dialogFlg"
      width="auto"
      max-width="100%"
    >
      <v-locale-provider :locale="$i18n.locale">
          <v-date-picker
            v-model="selectedDate"
            type="date"
            :day-format="(date) => new Date(date).getDate()"
            @update:model-value="dateSelected"
            no-title
            hide-header
            color="primary"
          >
          </v-date-picker>
        </v-locale-provider>
    </v-dialog>
    
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";
import VueLoading from '@/components/pages/Loding.vue';
import DatePager from '@/components/molecules/DatePager.vue';
import ChildDiary from '@/components/molecules/ChildDiary.vue';
import EatingRecord from '@/components/molecules/EatingRecord.vue';
import OtherRecord from '@/components/molecules/OtherRecord.vue';

import dayjs from 'dayjs';
import LocalDataService from '@/service/LocalDataService';
import { chatModule } from '@/store/dataModules/chatModule';
import { nurseryModule } from '@/store/dataModules/nurseryModule';
import {
  DiaryResponse,
  MeNurserySchoolResponse,
  MeResponse,
  NurseryAttendanceResponse,
  NurseryChildResponse,
  NurseryClassResponse,
} from 'chaild-api/lib';
import { childrenModule } from '@/store/dataModules/childrenModule';
import { ChildrenDiaryResponse, GetAttendanceSearchResponse, GetChildrenResponse } from '@/model/Response';
import { attendanceModule } from '@/store/dataModules/attendanceModule';
import { commonModule } from '@/store/viewModule/commonModule';
import { meModule } from '@/store/dataModules/meModule';

export default defineComponent({
  components: {
    VueLoading,
    DatePager,
    ChildDiary,
    EatingRecord,
    OtherRecord,
  },

  data: () => {
    return {
      fetchLoading: false,
      date: '' as any,
      tabIndex: 0,
      classId: 0,
      dialogFlg: false,
      selectedDate: dayjs().format('YYYY-MM-DD'),
      addflg: false,
      subtractflg: false,
    };
  },
  computed: {
    clas(): NurseryClassResponse | null {
      if (nurseryModule.clas) {
        return nurseryModule.clas;
      }
      return null;
    },
    children(): NurseryChildResponse[] | null {
      if (childrenModule.children) {
        const children = childrenModule.children.children.filter(child => !(child.quitDate && child.quitDate < this.date.format('YYYY-MM-DD')) )
        return children;
      }
      return null;
    },
    absenceAttendance(): NurseryAttendanceResponse[] | null {
      if (attendanceModule.attendances && attendanceModule.attendances.attendances) {
        return attendanceModule.attendances.attendances;
      }
      return null;
    },
    showLoader(): boolean {
      if (commonModule.showLoader) {
        return commonModule.showLoader;
      }
      return false;
    },
    diaries(): DiaryResponse[] | null {
      if (childrenModule.diary && childrenModule.diary.diaries) {
        return childrenModule.diary.diaries;
      }
      return null;
    },
    me(): MeResponse | null {
      const me = LocalDataService.getUser();
      return me;
    },
    currentScool(): MeNurserySchoolResponse | undefined {
      if (this.me) {
        let nurserySchool = this.me.nurserySchools.find(nursery => nursery.isDefault === true);
        if (this.me.nurserySchools.length === 0) {
          return undefined
        }
        if (!nurserySchool) {
          nurserySchool = this.me.nurserySchools[0];
        }
        return nurserySchool;
      }
      return undefined;
    },
    features(): Array<{
      name: string; // 機能名
      slug: string; // 機能スラッグ
      isEnabled: boolean; // 機能有効フラグ
    }> {
      if (this.currentScool) {
        const messageFeature = this.currentScool.applicationPlan.nurseryMobile.featureGroups.find((fg) => fg.name === "記録");
        if (!messageFeature) {
          return [];
        }
        return messageFeature.features.filter((f) => f.isEnabled);
      }
      return [];
    },
    shouldShowRecords() {
      const find = this.features.find((f) => f.slug === "nursery-mobile-record-report");
      if (find) {
        return true;
      }
      return false;
    },
    shouldShowDiary() {
      const find = this.features.find((f) => f.slug === "nursery-mobile-record-diary");
      if (find) {
        return true;
      }
      return false;
    },
    shouldShowMeal() {
      const find = this.features.find((f) => f.slug === "nursery-mobile-record-meal");
      if (find) {
        return true;
      }
      return false;
    },
    shouldShowClassDiary() {
      const find = this.features.find((f) => f.slug === "nursery-mobile-record-class-diary");
      if (find) {
        return true;
      }
      return false;
    },
  },
  watch: {
    date: {
      handler() {
        this.init();
      },
      deep: true,
    },
    tabIndex: {
      handler () {
        LocalDataService.setRecordsTabIndex(this.tabIndex)
      }
    }
  },
  methods: {
    addDay() {
      this.date = this.date.add(1, 'd');
      sessionStorage.setItem('classRecordDate', this.date.format('YYYY-MM-DD'));
      this.addflg = true;
    },
    subtractDay() {
      this.date = this.date.subtract(1, 'd');
      sessionStorage.setItem('classRecordDate', this.date.format('YYYY-MM-DD'));
      this.subtractflg = true;
    },
    toClassDiary() {
      const classId = this.$route.params.classId;
      this.$router.push({
        path:`/record/class-diary/${classId}`,
        query: { date: `${this.date.toISOString()}` }
      });
    },
    openDialog() {
      if (this.addflg || this.subtractflg) {
        this.addflg = false;
        this.subtractflg = false;
        return
      }
      this.selectedDate = this.date.format('YYYY-MM-DD');
      this.dialogFlg = true;
    },
    dateSelected(day) {
      this.date = dayjs(day);
      this.selectedDate = dayjs(day).format('YYYY-MM-DD');
      sessionStorage.setItem('classRecordDate', this.date.format('YYYY-MM-DD'));
      this.dialogFlg = false;
    },
    async init() {
      this.fetchLoading = true;
      const user = LocalDataService.getUser();
      const classId = this.$route.params.classId as string;
      this.classId = parseInt(classId, 10);
      this.tabIndex = LocalDataService.getRecordsTabIndex()
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        const nurseryId = nurserySchool.nurseryId;
        Promise.all([
          nurseryModule.getNurseryClassDetail({
            nurseryId,
            classId: this.classId,
          }),
          childrenModule.getChildren({
            classId: this.classId,
            nurseryId
          }),
          attendanceModule.searchAttendance({
            date: this.date.format('YYYY-MM-DD'),
            nurseryId,
            absence: 0,
            classId: this.classId,
          }),
          childrenModule.getChildDiary({
            classId: this.classId,
            date: this.date.format('YYYY-MM-DD'),
          })
        ]);
      }
      await this.$nextTick();
      this.fetchLoading = false;
    },
    async goBackWithTab() {
      await sessionStorage.setItem('targetTab', 'record');
      this.$router.push('/')
    }
  },
  async created() {
    this.date = dayjs();
  },
  mounted() {
    this.init();
    const classRecordDate = sessionStorage.getItem('classRecordDate');
    if (classRecordDate) this.date = dayjs(classRecordDate);
  },
  beforeDestroy() {
    childrenModule.refreshChildren();
    meModule.setTabIndex('record')
  },
});
</script>
<style lang="scss" scoped>
@use '@/sass/variables.scss' as *;
</style>
